//NÃO MUDE AS STRINGS! ESTÃO ATRELADAS À BUILD
export enum EnvironmentEnum {
    Dev = 'development',
    Test = 'test',
    Production = 'production',
}
